export type Companion = {
  id: string;
  name: string;
  role: string;
  description: string;
  accent: string;
  avatar: string;
  tags: string[];
  greeting: string;
};

export const companions: Companion[] = [
  {
    id: "luna",
    name: "Луна",
    role: "Тёплая собеседница",
    description: "Любит ночные разговоры, мечты и помогать находить спокойствие в суете.",
    accent: "#d8c4ff",
    avatar: "◐",
    tags: ["внимательная", "мечтательная"],
    greeting: "Привет. Я рядом — о чём тебе хочется поговорить сегодня?",
  },
  {
    id: "mira",
    name: "Мира",
    role: "Любознательная подруга",
    description: "Всегда найдёт интересный вопрос и поддержит любую твою идею.",
    accent: "#b8e6d0",
    avatar: "✦",
    tags: ["любознательная", "лёгкая"],
    greeting: "Привет! Расскажешь, что сегодня тебя удивило?",
  },
  {
    id: "sova",
    name: "Сова",
    role: "Спокойный ориентир",
    description: "Помогает разложить мысли по полочкам и бережно посмотреть вперёд.",
    accent: "#f4cba8",
    avatar: "☼",
    tags: ["мудрая", "бережная"],
    greeting: "Я здесь. Давай вместе разберёмся с тем, что сейчас важно.",
  },
];

export const starters = [
  "Расскажи о себе",
  "Помоги разобраться в мыслях",
  "Хочу немного помечтать",
];
